import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/auth-store';
import { getCommercialFxRates } from './api';

/** Query key prefix of the commercial rates; org-settings invalidates it by this literal. */
export const COMMERCIAL_FX_RATES_KEY = ['fx-rates', 'commercial'] as const;

export function useCommercialFxRates() {
  const { status } = useAuth();
  return useQuery({
    queryKey: COMMERCIAL_FX_RATES_KEY,
    queryFn: getCommercialFxRates,
    staleTime: 5 * 60_000,
    enabled: status === 'authed',
  });
}
